import {
  Checkbox as NCheckbox,
  type CheckboxProps as NCheckboxProps,
} from '@natera/material/lib/checkbox'
import { useId } from 'react'
import { Text } from '~/shared/ui/text'

export function Checkbox({ label, ...rest }: NCheckboxProps) {
  const id = useId()

  return (
    <NCheckbox
      id={id}
      label={
        !!label && (
          <Text
            className="ml-1"
            appearance="BODY2"
          >
            {label}
          </Text>
        )
      }
      {...rest}
    />
  )
}
